import { DataSyncAction, DestinationDataState, Destination } from '../../../types';
import { ActionTypes } from '../../actionTypes';

export const initialDestinationDataState: DestinationDataState = {
  destinations: [],
  loading: true,
  error: false,
};

export const destinationReducer = (
  state = initialDestinationDataState,
  action?: DataSyncAction,
) => {
  switch (action?.type) {
    case ActionTypes.FETCH_DESTINATIONS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };

    case ActionTypes.FETCH_DESTINATIONS_RESPONSE: {
      const destinations = (action?.payload as Destination[]) || [];

      return {
        destinations,
        error: false,
        loading: false,
      };
    }

    case ActionTypes.FETCH_DESTINATIONS_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
